/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SupervisorPhotoUrlResponseUrl } from './supervisorPhotoUrlResponseUrl';

/**
 * Short-lived SAS URL (or None) for the supervisor's profile photo.
 */
export interface SupervisorPhotoUrlResponse {
  url?: SupervisorPhotoUrlResponseUrl;
}
